import { Heart } from "lucide-react";

export const TelcaVoIPBadge = () => (
  <a 
    href="https://telcavoip.ai" 
    target="_blank" 
    rel="noopener noreferrer"
    className="inline-flex items-center gap-2 text-gray-500 hover:text-lojack-red transition-colors text-sm"
    data-testid="telcavoip-badge"
  >
    Made with <Heart className="w-4 h-4 text-lojack-red fill-current" /> by TelcaVoIP AI
  </a>
);
